module.exports = __webpack_public_path__ + "static/media/img009.f8432525.jpg";